#### Removal of `CommissionOnly` pay type

On 21st December 2023, the `CommissionOnly` pay type will be removed from the SEEK API.
This pay type sees near-zero usage and can lead to compliance issues with local labour laws and our terms of use.

From this date, if a hirer selects the “Commission only” pay option in your software, the SEEK API will fail their subsequent request to [post a job ad](/use-cases/job-posting/managing-job-ads/posting-a-job-ad).
We highly recommend that you remove or disable this option from your job posting workflow.
See our [pay type documentation](/use-cases/job-posting/salary#pay-type) for more information on valid pay types.
